import { GravyBinder } from "gravy-bind";

export class LoginStatus {
    hasLoaded = false;
    hasErrored = false;
    isLoggedIn = null;
    loggedInUsername = null;
    public binder: GravyBinder;
    public static id = 'navigation-menu-ctx';

    constructor(element: HTMLElement) {
        this.binder = new GravyBinder(this, element);
        this.binder.updateOutwardBindings();

        //ToDo: During INC-5239
        this.checkStatus();
    }

    checkStatus = () => {
        try {
            fetch('/apic/loginstatus/basic', {
                method: 'get',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                const responseClone: Response = response.clone();
                var data = responseClone.body;
                if (!response.ok) {
                    this.onError();
                } else {
                    response.json().then(o => {
                        this.hasLoaded = true;
                        this.isLoggedIn = o;
                        this.binder.updateOutwardBindings();
                    });
                }
            }).catch(this.onError)
        } catch (e) {
            this.onError();
        }

        
    };

    onError = () => {
        this.hasErrored = true;
        this.binder.updateOutwardBindings();
    };

    hideLogin = () => !this.hasLoaded || this.isLoggedIn;

    hideAccount = () => !this.hasLoaded || !this.isLoggedIn;

    hideJoin = () => !this.hasLoaded || this.isLoggedIn;

    hideLogout = () => !this.hasLoaded || !this.isLoggedIn;

    getLoggedInUsername = () => this.isLoggedIn ? this.loggedInUsername : null;

    getLoginLink = (plainLogin: string) => `${plainLogin}?ReturnUrl=${encodeURIComponent(window.location.href)}`
}
